import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Button,
  Row,
  Label,
  Alert,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import moment from "moment";
import { CircularProgress } from "@material-ui/core";


const AddPaymentSlider = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const [page, setPage] = useState();
  const [description, setDescription] = useState();
  const [title1, setTitle1] = useState();
  const [description1, setDescription1] = useState();
  const [buttonLink1, setButtonLink1] = useState();
  const [buttonText1, setButtonText1] = useState();
  const [title2, setTitle2] = useState();
  const [description2, setDescription2] = useState();
  const [mainButtonText, setMainButtonText] = useState();
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [propsData, setPropsData] = useState(props?.location?.state);
  const [loader,setLoader]=useState(false)


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);

    if (props.location.state?.edit) {
      setPropsData(props?.location?.state);
      var page = props?.location?.state?.item?.page_name;
      // var description = props?.location?.state?.item?.banner_text;
      var title1 = props?.location?.state?.item?.title_1;
      var description1 = props?.location?.state?.item?.title_1_description;
      var buttonLink1 = props?.location?.state?.item?.title_1_button_link;
      var buttonText1 = props?.location?.state?.item?.title_1_button_text;
      var title2 = props?.location?.state?.item?.title_2;
      var description2 = props?.location?.state?.item?.title_2_description;
      var mainButtonText = props?.location?.state?.item?.button_text;

      setPage(page);
      setDescription(description);
      setTitle1(title1);
      setDescription1(description1);
      setButtonLink1(buttonLink1);
      setButtonText1(buttonText1);
      setTitle2(title2);
      setDescription2(description2);
      setMainButtonText(mainButtonText);
    }
  }, []);

  const handleSubmit = () => {
    if (!page) {
      setErrorMessage("Please Enter Page");
      setErrorAlert(true);
      return;
    } else if (!title1) {
      setErrorMessage("Please Enter Title (Section 1)");
      setErrorAlert(true);
      return;
    } else if (!buttonLink1) {
      setErrorMessage("Please Enter Button Link (Section 1)");
      setErrorAlert(true);
      return;
    } else if (!buttonText1) {
      setErrorMessage("Please Enter Button Text (Section 1)");
      setErrorAlert(true);
      return;
    } else if (!description1) {
      setErrorMessage("Please Enter description (Section 1)");
      setErrorAlert(true);
      return;
    } else if (!title2) {
      setErrorMessage("Please Enter Title (Section 2)");
      setErrorAlert(true);
      return;
    } else if (!mainButtonText) {
      setErrorMessage("Please Enter Main Button Text (Section 2) ");
      setErrorAlert(true);
      return;
    } else if (!description2) {
      setErrorMessage("Please Enter Description (Section 2)");
      setErrorAlert(true);
      return;
    }

    setLoader(true)

    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("path", "cms/add");
    formdata.append("item_type", "cms");
    formdata.append("created_datetime", currentDate);
    formdata.append("page_name", page);
    // formdata.append("banner_text", description);
    formdata.append("title_1", title1);
    formdata.append("title_1_description", description1);
    formdata.append("title_1_button_text", buttonText1);
    formdata.append("title_1_button_link", buttonLink1);
    formdata.append("title_2", title2);
    formdata.append("title_2_description", description2);
    formdata.append("button_text", mainButtonText);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
        response.json();
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const handleEdit = () => {
    if (!page) {
      setErrorMessage("Please Enter Page");
      setErrorAlert(true);
      return;
    } else if (!title1) {
      setErrorMessage("Please Enter Title (Section 1)");
      setErrorAlert(true);
      return;
    } else if (!buttonLink1) {
      setErrorMessage("Please Enter Button Link (Section 1)");
      setErrorAlert(true);
      return;
    } else if (!buttonText1) {
      setErrorMessage("Please Enter Button Text (Section 1)");
      setErrorAlert(true);
      return;
    } else if (!description1) {
      setErrorMessage("Please Enter description (Section 1)");
      setErrorAlert(true);
      return;
    } else if (!title2) {
      setErrorMessage("Please Enter Title (Section 2)");
      setErrorAlert(true);
      return;
    } else if (!mainButtonText) {
      setErrorMessage("Please Enter Main Button Text (Section 2) ");
      setErrorAlert(true);
      return;
    } else if (!description2) {
      setErrorMessage("Please Enter Description (Section 2)");
      setErrorAlert(true);
      return;
    }

    setLoader(true)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("item_id", propsData?.item?.item_id);
    formdata.append("path", "cms/update");
    formdata.append("item_type", "cms");
    formdata.append("page_name", page);
    // formdata.append("banner_text", description);
    formdata.append("title_1", title1);
    formdata.append("title_1_description", description1);
    formdata.append("title_1_button_text", buttonText1);
    formdata.append("title_1_button_link", buttonLink1);
    formdata.append("title_2", title2);
    formdata.append("title_2_description", description2);
    formdata.append("button_text", mainButtonText);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200){
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/payment-sliders");
          setSuccesAlert(false);
        }}
        onConfirm={() => {
          props?.history.push("/payment-sliders");
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {props?.location?.state?.edit
          ? "Payment Slider Updated Successfully"
          : "Payment Slider Add Successfully"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Add Payment Slider" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card
                      style={{
                        border: "2px solid #EEEEEE",
                        borderRadius: "20px",
                      }}
                    >
                      <CardBody>
                      {/* <Row>
                          <Col md={3} className="mb-4">
                            <h2
                              style={{ color: "#47525d57", fontWeight: "700" }}
                            >
                              Page
                            </h2>
                          </Col>
                        </Row> */}
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Page</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="page_input"
                                  onChange={(e) => {
                                    setPage(e.target.value);
                                  }}
                                  defaultValue={page}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        {/* <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Description</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="description_input"
                                  onChange={(e) => {
                                    setDescription(e.target.value);
                                  }}
                                  defaultValue={description}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row> */}
                      </CardBody>
                    </Card>
                    {/* <Row>
                      <Col md={12}>
                        <Alert
                          style={{
                            fontWeight: 700,
                            textTransform: "uppercase",
                          }}
                          color="success"
                        >
                          Section 1
                        </Alert>
                      </Col>
                    </Row> */}

                    <Card
                      style={{
                        border: "2px solid #EEEEEE",
                        borderTop: "3px solid rgba(71, 82, 93, 0.34)",
                        borderRadius: "20px",
                      }}
                    >
                      <CardBody>
                        <Row>
                          <Col md={3} className="mb-4">
                            <h2
                              style={{ color: "#47525d57", fontWeight: "700" }}
                            >
                              Section 1
                            </h2>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Title</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="title_input"
                                  onChange={(e) => {
                                    setTitle1(e.target.value);
                                  }}
                                  defaultValue={title1}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Button Link</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="button_link_input"
                                  onChange={(e) => {
                                    setButtonLink1(e.target.value);
                                  }}
                                  defaultValue={buttonLink1}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Button Text</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="button_text_input"
                                  onChange={(e) => {
                                    setButtonText1(e.target.value);
                                  }}
                                  defaultValue={buttonText1}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label>Description</Label>
                              <div className="col-md-12">
                                <textarea
                                  cols={20}
                                  rows={4}
                                  className="form-control"
                                  type="text"
                                  id="description_1_input"
                                  onChange={(e) => {
                                    setDescription1(e.target.value);
                                  }}
                                  defaultValue={description1}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    {/* <Row>
                      <Col md={12}>
                        <Alert
                          style={{
                            fontWeight: 700,
                            textTransform: "uppercase",
                          }}
                          color="success"
                        >
                          Section 2
                        </Alert>
                      </Col>
                    </Row> */}
                    <Card
                      style={{
                        border: "2px solid #EEEEEE",
                        borderTop: "3px solid rgba(71, 82, 93, 0.34)",
                        borderRadius: "20px",
                      }}
                    >
                      <CardBody>
                        <Row>
                          <Col md={3} className="mb-4">
                            <h2
                              style={{ color: "#47525d57", fontWeight: "700" }}
                            >
                              Section 2
                            </h2>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Title</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="title_2_input"
                                  onChange={(e) => {
                                    setTitle2(e.target.value);
                                  }}
                                  defaultValue={title2}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Main Button Text</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="button_text_input"
                                  onChange={(e) => {
                                    setMainButtonText(e.target.value);
                                  }}
                                  defaultValue={mainButtonText}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <div className="mb-3">
                              <Label>Description</Label>
                              <div className="col-md-12">
                                <textarea
                                  cols={20}
                                  rows={4}
                                  className="form-control"
                                  type="text"
                                  id="description_2_input"
                                  onChange={(e) => {
                                    setDescription2(e.target.value);
                                  }}
                                  defaultValue={description2}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/payment-sliders");
                        }}
                        color="danger"
                        type="submit"
                      >
                        {" "}
                        Cancel
                      </Button>
                      <button
                      disabled={loader}
                      style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                      className={ "btn btn-success"}
                        onClick={() => {
                          if (props?.location?.state?.edit) {
                            handleEdit();
                          } else {
                            handleSubmit();
                          }
                        }}
                        // className="px-4"
                        color="success"
                        type="submit"
                      >
                        {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddPaymentSlider;
